import type { SVGProps } from 'react'
const SvgSyAlarm = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path
			fillOpacity={0.24}
			d="M9.15 7.831a2.976 2.976 0 1 1 5.7 0l-1.563 5.211c-.07.234-.105.351-.159.448a1 1 0 0 1-.654.486C12.366 14 12.244 14 12 14s-.366 0-.474-.024a1 1 0 0 1-.654-.486c-.054-.097-.09-.214-.16-.448z"
		/>
		<path d="M12 3.4c-2.38 0-4.11 2.325-3.426 4.604l1.565 5.21c.07.235.11.389.21.57.223.395.603.677 1.046.777.201.045.36.039.605.039s.404.006.605-.04c.443-.099.823-.38 1.045-.777.102-.18.141-.334.211-.568l1.565-5.211C16.109 5.725 14.379 3.4 12 3.4m0 1.2a2.36 2.36 0 0 1 2.275 3.058l-1.562 5.211c-.07.234-.1.314-.108.326a.4.4 0 0 1-.261.196c-.014.003-.1.01-.344.01s-.33-.007-.344-.01a.4.4 0 0 1-.261-.196 3 3 0 0 1-.108-.326L9.725 7.66A2.36 2.36 0 0 1 12 4.598" />
		<path fillOpacity={0.24} d="M14 19a2 2 0 0 1-2 2 2 2 0 0 1-2-2 2 2 0 0 1 2-2 2 2 0 0 1 2 2" />
		<path d="M12 16.4c-1.429 0-2.6 1.171-2.6 2.6s1.171 2.6 2.6 2.6 2.6-1.171 2.6-2.6-1.171-2.6-2.6-2.6m0 1.2c.78 0 1.4.62 1.4 1.4s-.62 1.4-1.4 1.4-1.4-.62-1.4-1.4.62-1.4 1.4-1.4" />
	</svg>
)
export default SvgSyAlarm
